import React from "react";

interface ToolbarProps {
  children: React.ReactNode;
  className?: string;
}

interface ToolbarGroupProps {
  children: React.ReactNode;
  className?: string;
}

interface ToolbarSegmentProps {
  children: React.ReactNode;
  className?: string;
  interactive?: boolean;
}

interface ToolbarDividerProps {
  orientation?: "vertical" | "horizontal";
  className?: string;
}

export function Toolbar({ children, className = "" }: ToolbarProps) {
  return (
    <div className={`flex items-center justify-between  ${className}`}>
      {children}
    </div>
  );
}

export function ToolbarGroup({ children, className = "" }: ToolbarGroupProps) {
  return (
    <div
      className={`flex items-center border text-slate-800 h-[32px] leading-none dark:text-slate-200 border-slate-300 dark:border-slate-700 rounded-md divide-x divide-slate-300 dark:divide-slate-700 ${className}`}
    >
      {children}
    </div>
  );
}

export function ToolbarSegment({
  children,
  className = "",
  interactive = false,
}: ToolbarSegmentProps) {
  const interactiveClasses = interactive ? "cursor-pointer" : "";

  return (
    <div
      className={`flex items-center h-full px-1 py-0.5 ${interactiveClasses} ${className}`}
    >
      {children}
    </div>
  );
}

export function ToolbarDivider({
  orientation = "vertical",
  className = "",
}: ToolbarDividerProps) {
  const orientationClasses =
    orientation === "vertical" ? "h-full w-[1px]" : "w-full h-[1px]";

  return (
    <div
      className={`bg-slate-300 dark:bg-slate-700 ${orientationClasses} ${className}`}
    />
  );
}

export default Toolbar;
